export const loginIdSelector = (state) => state.auth.loginId;
export const loginCurrentStepSelector = (state) => state.auth.loginCurrentStep;
